<template>
  <v-dialog
    @keydown.esc="closeDialog"
    v-model="dialog"
    max-width="600px"
    @click:outside="closeDialog"
  >
    <v-card>
      <v-card-title>
        {{ $tc('verify_checksum') }}

        <v-spacer />

        <v-tooltip top>
          <template #activator="{ on }">
            <v-btn
              id="close"
              icon
              @click="closeDialog"
              v-on="on"
            >
              <v-icon>close</v-icon>
            </v-btn>
          </template>
          <span>{{ $tc("close") }} </span>
        </v-tooltip>
      </v-card-title>

      <v-card-text>
        <v-row>
          <v-col cols="12">
            <div class="mb-3">
              <app-drag-and-drop
                ref="uploadarea"
                @file="addFile"
                @fileRemoved="fileRemoved"
              />
            </div>

            <v-row justify="end" class="mr-3">
              <v-btn
                color="blue"
                :dark="file !== null"
                :disabled="file === null"
                @click="verifyChecksum"
              >
                {{ $tc('verify') }}
              </v-btn>
            </v-row>
          </v-col>

          <v-col cols="12">
            <div v-if="showResult" class="mb-3">
              <div v-if="isMatch">
                <v-alert
                  style="background: transparent;"
                  border="left"
                  colored-border
                  type="success"
                >
                  {{
                    $tc("match_verify")
                  }}
                </v-alert>
              </div>

              <div v-else>
                <v-alert
                  style="background: transparent;"
                  border="left"
                  colored-border
                  type="error"
                >
                  {{
                    $tc("mismatch_verify")
                  }}
                </v-alert>

                <v-text-field
                  label="HSM_OBJ_PVALUE"
                  v-model="blobPValue"
                  counter
                  readonly
                />

                <v-text-field
                  :label="$tc('selected_file_checksum')"
                  v-model="selectedFileChecksum"
                  counter
                  readonly
                />
              </div>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import AppDragAndDrop from '@/components/ui/AppDragAndDrop'

export default {
  components: {
    AppDragAndDrop
  },
  props: {
    dialogVisible: {
      type: Boolean,
      required: true
    },
    pValue: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      dialog: false,
      file: null,
      isMatch: false,
      showResult: false,
      selectedFileChecksum: null,
      blobPValue: null
    }
  },
  methods: {
    closeDialog () {
      this.$emit('close-dialog')
    },
    addFile (file) {
      this.file = file
    },
    fileRemoved () {
      this.file = null
      this.isMatch = false
      this.showResult = false
      this.selectedFileChecksum = null
    },
    async verifyChecksum () {
      if (!this.file) {
        // Se nenhum arquivo estiver selecionado, não faça nada
        return
      }

      // Lê o arquivo como um ArrayBuffer
      const fileData = await this.readFileAsArrayBuffer(this.file)

      // Calcula o SHA-1 do arquivo
      const sha1Digest = await this.calculateSHA1(fileData)

      // Calcula o SHA-1 do SHA-1 Digest (duplo SHA-1)
      const doubleSHA1Digest = await this.calculateSHA1(sha1Digest)

      // Converte o resultado em hexadecimal
      const hexadecimalResult = this.arrayBufferToHex(doubleSHA1Digest)

      this.blobPValue = this.pValue
      this.selectedFileChecksum = hexadecimalResult.toUpperCase()
      this.isMatch = this.pValue.toUpperCase() === hexadecimalResult.toUpperCase()
      this.showResult = true
    },

    async readFileAsArrayBuffer (file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()

        reader.onload = () => {
          resolve(reader.result)
        }

        reader.onerror = () => {
          reject(new Error('Erro ao ler o arquivo como ArrayBuffer'))
        }

        reader.readAsArrayBuffer(file)
      })
    },

    async calculateSHA1 (data) {
      const buffer = await crypto.subtle.digest('SHA-1', data)
      return new Uint8Array(buffer)
    },

    arrayBufferToHex (buffer) {
      const hexArray = Array.from(new Uint8Array(buffer))
        .map(byte => byte.toString(16).padStart(2, '0'))
      return hexArray.join('')
    }
  },
  watch: {
    dialogVisible (val) {
      this.dialog = val
    }
  }
}
</script>
